import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import AssignedTable from "./AssignedTable";
import NotAssignedTable from "./NotAssignedTable";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "0",
    },
    backgroundColor: "transparent",
    width: "85%",
    color: "black",
    boxShadow: "none",
  },
  panel: {
    "& .MuiBox-root": {
      padding: "0px",
    },
  },
}));

export default function UserManagementBaseClients({
  assignedRoles,
  unassignedBaseClients,
  populate,
  loading,
}) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <AppBar position="static" className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{ style: { backgroundColor: "rgba(0,0,0,.3)" } }}
        >
          <Tab
            label={"Assigned (" + assignedRoles.length + ")"}
            {...a11yProps(0)}
          />
          <Tab
            label={"Not Assigned (" + unassignedBaseClients.length + ")"}
            {...a11yProps(1)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} className={classes.panel}>
        <AssignedTable
          assignedRoles={assignedRoles}
          populate={populate}
          loading={loading}
        />
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.panel}>
        <NotAssignedTable
          unassignedBaseClients={unassignedBaseClients}
          populate={populate}
          loading={loading}
        />
      </TabPanel>
    </div>
  );
}
